// REDESIGN 2024

// Tento skript vychází ze starých skriptů, které byly vytvořeny pro starý design navigace
// Slouží kvůli černé plachtě otevřené pomocí navigace

export const html = document.documentElement;

export const configureFullNav = (): void => {
    const fullNav = document.querySelector<HTMLElement>('.js-blesk-full-nav');

    if (!fullNav) {
        return;
    }

    const openFullNavButtons: NodeListOf<HTMLElement> =
        document.querySelectorAll('[data-open-nav]');
    const closeFullNavButtons: NodeListOf<HTMLButtonElement> =
        document.querySelectorAll('[data-close-nav]');
    const searchInput: HTMLInputElement | null = fullNav.querySelector(
        '.js-blesk-full-nav__input--search',
    );

    const openFullNav = (): void => {
        fullNav.classList.add('blesk-full-nav--show');
        html.style.overflow = 'hidden';
    };

    const closeFullNav = (): void => {
        fullNav.classList.add('blesk-full-nav--hide');
        html.style.overflow = 'visible';

        fullNav.classList.remove('blesk-full-nav--show');
        fullNav.classList.remove('blesk-full-nav--hide');
    };

    const cncGa4ToggleMenu = (linkText: string): void => {
        if (Array.isArray(window.dataLayer)) {
            window.dataLayer.push({
                event: 'clickTo_navigation',
                menu: {
                    type: 'menu',
                },
                link: {
                    text: linkText,
                },
            });
        }
    };

    const openButtonOnClick = (e: Event): void => {
        e.preventDefault();

        openFullNav();

        const target = e.currentTarget as HTMLElement;
        if (target.classList.contains('js-focus-search-input')) {
            searchInput?.focus();
            cncGa4ToggleMenu('openSearch');
        } else {
            cncGa4ToggleMenu('open');
        }
    };

    const configureFullNavOpening = (): void => {
        openFullNavButtons.forEach((openButton) => {
            openButton.addEventListener('click', openButtonOnClick);
        });
    };

    const closeButtonOnClick = (e: Event): void => {
        e.preventDefault();

        closeFullNav();

        cncGa4ToggleMenu('close');
    };

    const closeButtonOnKeydown = (e: KeyboardEvent): void => {
        const isEscapeKey = e.keyCode === 27;

        if (isEscapeKey) {
            e.preventDefault();

            closeFullNav();

            cncGa4ToggleMenu('closeEsc');
        }
    };

    const configureFullNavClosing = (): void => {
        closeFullNavButtons.forEach((closeButton) =>
            closeButton.addEventListener('click', closeButtonOnClick),
        );

        document.addEventListener('keydown', closeButtonOnKeydown);
    };

    configureFullNavOpening();
    configureFullNavClosing();
};
